/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportDtoSpecies = (typeof LabReportDtoSpecies)[keyof typeof LabReportDtoSpecies] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportDtoSpecies = {
  M_TUBERCULOSIS: 'M_TUBERCULOSIS',
  M_BOVIS: 'M_BOVIS',
  M_BOVIS_BCG: 'M_BOVIS_BCG',
  M_CAPRAE: 'M_CAPRAE',
  M_AFRICANUM: 'M_AFRICANUM',
  M_TUBERCULOSIS_COMPLEX: 'M_TUBERCULOSIS_COMPLEX',
} as const;
